/* src/app/send-data/send-data.component.scss */
.send-data {
  width: 100%;
  height: 100%;
  position: absolute;
}
@media (min-width: 768px) {
  .send-data {
    max-width: 414px;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
  }
}
.download-share-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  gap: 1rem;
}
.small-text-box {
  font-size: 0.8rem;
  margin-top: 0.8rem;
}
.content {
  position: relative;
  background: white;
  width: 100%;
  max-width: 90%;
  margin: 25px auto;
  padding: 20px;
  border-radius: 6px;
  max-height: 80vh;
  height: 100%;
  overflow-y: auto;
}
p {
  margin: 25px auto;
}
a {
  text-align: center;
  display: block;
}
button {
  padding: 20px;
  color: #fff;
  border-radius: 100px;
  font-size: 14px;
  background: #4ac8f3;
  width: 100%;
  text-align: center;
}
/*# sourceMappingURL=send-data.component.css.map */
